"use client";

import { createContext, use, useState, type ReactNode } from "react";

export interface SupportHandoff {
  question: string;
  transcript: string;
  threadId: string | null;
}

interface SupportHandoffValue {
  handoff: SupportHandoff | null;
  setHandoff: (handoff: SupportHandoff | null) => void;
}

const SupportHandoffContext = createContext<SupportHandoffValue | null>(null);

export function SupportHandoffProvider({ children }: { children: ReactNode }) {
  const [handoff, setHandoff] = useState<SupportHandoff | null>(null);
  return (
    <SupportHandoffContext value={{ handoff, setHandoff }}>
      {children}
    </SupportHandoffContext>
  );
}

export function useSupportHandoff(): SupportHandoffValue {
  const value = use(SupportHandoffContext);
  if (!value) {
    throw new Error("useSupportHandoff must be used inside SupportHandoffProvider");
  }
  return value;
}
